/* TC THEME — küçük etkileşimler (Dawn'ın kendi JS'ine dokunmadan) */
(function () {
  if (window.__tcThemeInit) return;
  window.__tcThemeInit = true;

  const ICON_LEFT =
    '<svg class="tc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>';
  const ICON_RIGHT =
    '<svg class="tc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';

  /* ---------- Hero video durdur / oynat ---------- */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-tc-video-toggle]');
    if (!toggle) return;
    const hero = toggle.closest('[data-tc-hero]');
    const videos = hero ? hero.querySelectorAll('video') : [];
    const anyPlaying = Array.from(videos).some((v) => !v.paused);
    videos.forEach((v) => (anyPlaying ? v.pause() : v.play()));
    toggle.textContent = anyPlaying ? '▶' : '❚❚';
  });

  /* ---------- Müşteri videoları ---------- */
  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-tc-sv-play]');
    const card = event.target.closest('[data-tc-sv-card]');
    if (!card) return;
    const video = card.querySelector('video');
    if (!video) return;

    if (play || card.classList.contains('is-playing')) {
      if (video.paused) {
        document.querySelectorAll('[data-tc-sv-card].is-playing').forEach((other) => {
          if (other === card) return;
          other.querySelector('video')?.pause();
          other.classList.remove('is-playing');
        });
        video.muted = false;
        video.play().catch(() => {
          video.muted = true;
          video.play();
        });
        card.classList.add('is-playing');
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    }
  });

  /* ---------- Footer akordeon (mobil) ---------- */
  document.addEventListener('click', (event) => {
    const title = event.target.closest('.tc-footer__col-title');
    if (!title) return;
    const col = title.closest('[data-tc-footer-col]');
    const open = col.classList.toggle('is-open');
    title.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Tahmini teslimat tarihleri ---------- */
  function addBusinessDays(date, days, skipWeekends) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (skipWeekends && (day === 0 || day === 6)) continue;
      added++;
    }
    return d;
  }

  function initDelivery(root = document) {
    const lang = document.documentElement.lang || 'tr';
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' });
    } catch (e) {
      fmt = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long' });
    }
    root.querySelectorAll('[data-tc-delivery]').forEach((el) => {
      const min = parseInt(el.dataset.min, 10) || 0;
      const max = parseInt(el.dataset.max, 10) || min;
      const skip = el.dataset.skipWeekends === 'true';
      const now = new Date();
      const target = el.querySelector('[data-tc-delivery-dates]');
      if (!target) return;
      target.textContent = `${fmt.format(addBusinessDays(now, min, skip))} - ${fmt.format(addBusinessDays(now, max, skip))}`;
    });
  }

  /* ---------- Ürün galerisi: oklar + mobil ilerleme çubuğu ---------- */
  function visibleThumbs(gallery) {
    return Array.from(gallery.querySelectorAll('.thumbnail-list__item')).filter(
      (li) => li.offsetParent !== null && getComputedStyle(li).display !== 'none'
    );
  }

  function stepGallery(gallery, dir) {
    const thumbs = visibleThumbs(gallery);
    if (thumbs.length < 2) return;
    let index = thumbs.findIndex((li) => li.querySelector('[aria-current="true"]'));
    if (index < 0) index = 0;
    const next = thumbs[(index + dir + thumbs.length) % thumbs.length];
    next.querySelector('button')?.click();
    next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  function initGalleries(root = document) {
    root.querySelectorAll('.tc-pdp media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer) return;

      // Masaüstü okları (küçük resimli düzende)
      if (gallery.querySelector('.thumbnail-list') && !viewer.querySelector('.tc-gallery-arrow')) {
        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'tc-gallery-arrow tc-gallery-arrow--prev';
        prev.setAttribute('aria-label', 'Önceki görsel');
        prev.innerHTML = ICON_LEFT;
        const next = prev.cloneNode(false);
        next.className = 'tc-gallery-arrow tc-gallery-arrow--next';
        next.setAttribute('aria-label', 'Sonraki görsel');
        next.innerHTML = ICON_RIGHT;
        prev.addEventListener('click', () => stepGallery(gallery, -1));
        next.addEventListener('click', () => stepGallery(gallery, 1));
        viewer.append(prev, next);
      }

      // Küçük resim sütunu ana görsel yüksekliğini geçmesin
      if ('ResizeObserver' in window && !gallery.__tcResize) {
        gallery.__tcResize = new ResizeObserver(() => {
          const h = viewer.getBoundingClientRect().height;
          if (h > 100) gallery.style.setProperty('--tc-thumbs-h', `${h}px`);
        });
        gallery.__tcResize.observe(viewer);
      }

      // Mobil ilerleme çubuğu
      const list = viewer.querySelector('.product__media-list');
      if (list && !viewer.parentElement.querySelector('.tc-gallery-progress')) {
        const bar = document.createElement('div');
        bar.className = 'tc-gallery-progress';
        bar.innerHTML = '<span></span>';
        viewer.insertAdjacentElement('afterend', bar);
        const update = () => {
          const max = list.scrollWidth - list.clientWidth;
          const ratio = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
          const width = Math.max(ratio * 100, 12);
          const pos = max > 0 ? (list.scrollLeft / max) * (100 - width) : 0;
          bar.style.setProperty('--tc-progress-w', `${width}%`);
          bar.querySelector('span').style.transform = `translateX(${(pos / width) * 100}%)`;
          bar.style.visibility = max > 4 ? 'visible' : 'hidden';
        };
        list.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  /* ---------- "Bununla Kombinle" kaydırma okları ---------- */
  function updateCompArrows(comp) {
    const track = comp.querySelector('[data-tc-comp-track]');
    if (!track) return;
    const prev = comp.querySelector('[data-tc-comp-prev]');
    const next = comp.querySelector('[data-tc-comp-next]');
    const max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-tc-comp-prev], [data-tc-comp-next]');
    if (!btn) return;
    const comp = btn.closest('[data-tc-comp]');
    const track = comp.querySelector('[data-tc-comp-track]');
    const item = track.querySelector('.tc-comp__item');
    const step = item ? item.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: btn.hasAttribute('data-tc-comp-next') ? step : -step, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const track = event.target.closest && event.target.closest('[data-tc-comp-track]');
      if (track) updateCompArrows(track.closest('[data-tc-comp]'));
    },
    true
  );

  /* ---------- Hızlı sepete ekle (tek varyantlı kombin ürünleri) ---------- */
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-tc-quick-add]');
    if (!btn) return;
    event.preventDefault();
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const formData = new FormData();
    formData.append('id', btn.dataset.tcQuickAdd);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(btn);
    }
    btn.classList.add('is-loading');
    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      });
      const data = await response.json();
      if (data.status) {
        window.alert(data.description || data.message);
        return;
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1600);
    } catch (e) {
      console.error(e);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------- Başlat ---------- */
  function init(root = document) {
    initDelivery(root);
    initGalleries(root);
    root.querySelectorAll('[data-tc-comp]').forEach(updateCompArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Varyant değişince (Dawn) teslimat/galeri yeniden kontrol
  // PUB_SUB_EVENTS constants.js'te top-level const olarak tanımlı (window'da değil)
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => init(), 50));
    }
  } catch (e) {
    /* pubsub yoksa sessizce geç */
  }
})();
